import { useStoreContext } from 'features/store';

import { useServiceModeLive } from 'state/service-mode';
import { isDelivery } from 'utils/service-mode';

export const useDebugToolPosVendor = () => {
  const { store } = useStoreContext();
  const serviceMode = useServiceModeLive();

  const posVendor = (store.pos?.vendor ?? '').trim().toLowerCase();
  const storePosVendor = isDelivery(serviceMode) ? `${posVendor}Delivery` : posVendor;

  return {
    storeNumber: store?.number ?? '',
    storePosVendor,
  };
};
